import { UsersApi } from '@linktivity/tata';
import config from '../config';

const usersApi = new UsersApi(config);

export default usersApi;
